import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";
import AttachmentLink from "../components/AttachmentLink";

export default function Projects() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="projects-page">
      <Seo title="Projekty" description="Dlhodobé projekty ObFZ Levice — podpora mládežníckeho futbalu, rozvoj rozhodcov, modernizácia infraštruktúry a vzdelávanie trénerov." />
      <PageHeader
        eyebrow="Aktivity ObFZ Levice"
        title="Projekty"
        description="Dlhodobé projekty Oblastného futbalového zväzu Levice — podpora mládeže, rozvoj rozhodcov, modernizácia infraštruktúry a vzdelávanie trénerov."
        breadcrumbs={[{ label: "Projekty" }]}
      />

      <section className="section-pad bg-paper">
        <div className="wrap">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-ink-100 border border-ink-100">
            {items.map((p, i) => (
              <article key={p.id} className="bg-white p-7 md:p-9 group hover:bg-cream transition-colors" data-testid={`project-${p.id}`}>
                <div className="flex items-start justify-between mb-5">
                  <span className="mono text-[11px] font-bold uppercase tracking-widest text-green-700">
                    PR/{String(i + 1).padStart(2, "0")} · {p.year}
                  </span>
                  {p.link && <ArrowUpRight className="w-5 h-5 text-ink-400 group-hover:text-green-700" />}
                </div>
                <h3 className="font-heading font-extrabold text-ink-900 text-2xl md:text-3xl leading-tight mb-4 tracking-tight">
                  {p.title}
                </h3>
                <p className="text-sm text-ink-500 leading-relaxed mb-5">{p.description}</p>
                {p.link && (
                  <a href={p.link} target="_blank" rel="noopener noreferrer"
                     className="inline-flex items-center gap-1.5 mono text-[11px] font-bold uppercase tracking-widest text-ink-900 hover:text-green-700">
                    Viac informácií <ArrowUpRight className="w-3.5 h-3.5" />
                  </a>
                )}
                {p.attachment_url && (
                  <div className="mt-4">
                    <AttachmentLink url={p.attachment_url} name={p.attachment_name} />
                  </div>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
